import { chaveDoGrupo } from '../catalogo.mock'

const MSG_OBRIGATORIO = 'Campo obrigatório'

const estaVazio = valor => valor === undefined || valor === null || valor === ''
const estaAtivo = item => !!(item && item.ativo)

// Chaves dos campos obrigatórios (quando ativo) que estão sem valor.
const camposObrigatoriosVazios = (campos, valor = {}) =>
  campos
    .filter(campo => campo.obrigatorioSeAtivo && estaVazio(valor[campo.chave]))
    .map(campo => campo.chave)

export const catalogo = state => state.catalogo
export const valores = state => state.valores
export const dadosRetorno = state => state.dadosRetorno
export const carregandoDados = state => state.flagsDeControle.carregandoDados
export const manipulandoDados = state => state.flagsDeControle.manipulandoDados

// Task 2.2 — contagem de produtos ativos por categoria (badge "N ativos")
export const contagemAtivosPorCategoria = state => {
  const contagem = {}
  state.catalogo.forEach(categoria => {
    contagem[categoria.id] = categoria.produtos.filter(produto => estaAtivo(state.valores[produto.slug])).length
  })
  return contagem
}

// Categorias cujo grupo tem pelo menos um consumidor ativo — fonte única para obrigatoriedade
// (errosDeValidacao) e para visibilidade (AcordeaoCategoriaProduto, via PainelGestaoProdutos).
export const gruposNecessarios = state => {
  const necessario = {}
  state.catalogo.forEach(categoria => {
    necessario[categoria.id] = !!(categoria.grupo &&
      categoria.produtos.some(produto => produto.usaTokenGrupo && estaAtivo(state.valores[produto.slug])))
  })
  return necessario
}

// Task 2.2 — validação condicional: campo obrigatório só quando o produto (ou o grupo) está ativo.
// Retorna { [chave]: { [campoChave]: mensagem } }; vazio quando válido.
export const errosDeValidacao = (state, getters) => {
  const erros = {}
  const registrar = (chave, campos) => {
    if (!campos.length) return
    erros[chave] = {}
    campos.forEach(campoChave => { erros[chave][campoChave] = MSG_OBRIGATORIO })
  }

  state.catalogo.forEach(categoria => {
    if (getters.gruposNecessarios[categoria.id]) {
      const grupoChave = chaveDoGrupo(categoria)
      const valorGrupo = (state.valores[grupoChave] || {}).valor
      registrar(grupoChave, camposObrigatoriosVazios(categoria.grupo.campos, valorGrupo))
    }
    // campos próprios de cada produto ativo
    categoria.produtos.forEach(produto => {
      const item = state.valores[produto.slug]
      if (estaAtivo(item)) {
        registrar(produto.slug, camposObrigatoriosVazios(produto.campos, item.valor))
      }
    })
  })
  return erros
}

export const formularioValido = (state, getters) => Object.keys(getters.errosDeValidacao).length === 0

// true quando o catálogo/valores já foram carregados (aba Produtos foi aberta) — usado pela edição
// do escritório para decidir se deve salvar as configurações junto com o Salvar do escritório.
export const temConfigCarregada = state => state.catalogo.length > 0
